<template>
    <div class="n2-container">
        <div class="n2-nav-back">
            <a @click="$router.go(-1)" class="n2-link-back">
                <div style="display: flex; align-items:center;">
                    <i aria-hidden="true" class="fa fa-angle-left" style="font-size:2em;"></i>
                    <span style="margin-left:5px;">
                        {{ $t('pages.admin.user.back') }}
                    </span>
                </div>
            </a>
        </div>
        <div class="n2-page-title">
            <h3 v-if="id === 'new'">{{ $t('pages.admin.user.new') }}</h3>
            <h3 v-else>{{ $t('pages.admin.user.user') }}</h3>
        </div>
        <div class="n2-container">
            <form method="post" v-on:submit.prevent="onSubmit">
                <div class="n2-row-padding">
                    <div class="col-md-12">
                        <div class="n2-panel-default">
                            <form-input type="text" v-model="entity.given_name"
                                v-bind:label="$t('pages.admin.user.given_name')"
                                v-bind:errors="model_errors.given_name"></form-input>
                            <form-input type="text" v-model="entity.family_name"
                                v-bind:label="$t('pages.admin.user.family_name')"
                                v-bind:errors="model_errors.family_name"></form-input>
                            <form-input type="text" v-model="entity.email" v-bind:label="$t('pages.admin.user.email')"
                                v-bind:errors="model_errors.email"></form-input>


                        </div>


                        <validation-summary v-bind:errors="model_errors"></validation-summary>

                        <div class="n2-form-group">
                            <div v-if="id === 'new'" class="n2-text-right">
                                <input type="submit" v-bind:value="$t('pages.admin.user.create')" class="n2-button-1" />
                            </div>
                            <div v-else class="n2-display-flex n2-justify-content-space-between">
                                <span class="n2-button-1 n2-button-delete"
                                    onclick="document.getElementById('n1-delete-modal').style.display='block'">{{ $t('pages.admin.user.delete') }}</span>
                                <input type="submit" v-bind:value="$t('pages.admin.user.save')" class="n2-button-1" />
                            </div>
                        </div>
                        <!--delete---------------------------------->
                        <div id="n1-delete-modal" class="w3-modal">
                            <div class="w3-modal-content w3-card-4" style="max-width:600px">
                                <div class="w3-center">
                                    <br>
                                    <span v-on:click="closeModal"
                                        class="w3-button w3-xlarge w3-hover-red w3-display-topright"
                                        title="Close Modal">&times;</span>
                                    <label class="n2-form-label">{{ $t('pages.admin.user.confirm_delete') }}</label>
                                </div>
                                <div class="w3-container w3-padding-16">
                                    <button type="button" class="n2-button-1 n2-button-delete n2-right"
                                        v-on:click="deleteEntity()">{{ $t('pages.admin.user.delete') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>


<script>
import { mapGetters } from 'vuex';
import {
    UserService

} from '../services';
import FormInput from "../components/shared/form-input.vue";
import ValidationSummary from "../components/shared/validation-summary.vue";


export default {
    components: {
        FormInput, ValidationSummary
    },
    props: {
    },
    data: function () {
        return {
            model_errors: {},
            id: '',
            languages: [],
            entity: {
                given_name: '',
                family_name: '',
                email: ''
            },


            lines: [],
            routes: [],
            routesets: [],
            journeys: [],
            journey_patterns: [],
            journey_pattern_sequences: [],


            line: null,
            route: null,
            journey: null,

            journey_pattern: null,
            journey_pattern_sequence: null,

        }
    },
    computed: {
        ...mapGetters('app_settings', [
            'company_id'
        ]),
        ...mapGetters('globalization', [
            'locale',
            'language'
        ]),

    },
    watch: {

    },
    created: function () {
        this.userService = new UserService();

    },
    mounted: async function () {
        const { id } = this.$route.params;
        this.id = id;
        if (id !== 'new') {
            await this.loadEntity(id);
        }
    },
    beforeRouteUpdate: async function (to, from, next) {
        if (to.query.company_id !== from.query.company_id || to.query.routeset_id !== from.query.routeset_id) {
            next({
                path: this.$route.path.substring(0, this.$route.path.lastIndexOf('/')), query: to.query
            });
        }
        else {
            next();
        }
    },
    methods: {
        setRequired: function (content, property, list, idContent, idList) {
            content[property] = content[property].map(req => {
                var result = list.find(element => element[idList] == req[idContent]);
                if (result) {
                    return result;
                }
                else {
                    return {};
                }
            });
        },
        loadEntity: async function (id) {
            this.entity = await this.userService.find(id);
        },



        closeModal: function () {
            var x = document.getElementsByClassName("w3-modal");
            var i;
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "none";
            }
        },





        validateForm: function () {
            this.model_errors = {}
            if (!this.entity.given_name) {
                this.model_errors['given_name'] = [this.$t('pages.admin.user.error_given_name')]
            }
            if (!this.entity.family_name) {
                this.model_errors['family_name'] = [this.$t('pages.admin.user.error_family_name')]
            }
            let patternEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!patternEmail.test(this.entity.email)) {
                this.model_errors['email'] = [this.$t('pages.admin.user.error_email')]
            }


            //////////////////
            if (Object.keys(this.model_errors).length > 0) {
                return false
            }
            else {
                return true
            }
        },
        onSubmit: async function () {
            if (!this.validateForm()) {
                return false;
            }
            try {
                if (this.id === 'new') {
                    await this.userService.create(this.entity);
                }
                else {
                    await this.userService.update(this.entity.id, this.entity);
                }
                var parentPath = this.$route.path.substring(0,
                    this.$route.path.endsWith('/') ?
                        this.$route.path.substr(0, this.$route.path.length - 2).lastIndexOf('/')
                        : this.$route.path.lastIndexOf('/'));
                this.$router.push({
                    path: parentPath,
                    query: this.$route.query
                }).catch(() => {
                    //throw new Error(`Problem router push: ${err}.`);
                });
            }
            catch (err) {
                if (err && err.data && err.data.errors) {
                    if (err.data.errors.email) {
                        this.$set(this.model_errors, 'email', [this.$t('pages.account.profile.error_email_exist')])
                    }
                }
            }
        },
        deleteEntity: async function () {
            try {
                await this.userService.delete(this.id);
                var parentPath = this.$route.path.substring(0,
                    this.$route.path.endsWith('/') ?
                        this.$route.path.substr(0, this.$route.path.length - 2).lastIndexOf('/')
                        : this.$route.path.lastIndexOf('/'));
                this.$router.push({
                    path: parentPath,
                    query: this.$route.query
                }).catch(() => {
                    //throw new Error(`Problem router push: ${err}.`);
                });
            }
            catch (err) {
                if (err.response) {
                    this.model_errors = err.response.data;
                }
            }
        },
    },

}
</script>